<template>
  <div class="px-6 pt-8">
    <AppDataProperty
      contentId="walletInfo"
      @dataAvailable="
        data => {
          walletInfo = data?.metaData || {}
        }
      "
    />
    <UserProperty
      @dataAvailable="
        data => {
          userData = data
        }
      "
    />
    <div class="">
      <div class="h-[18dvh] relative">
        <div
          class="absolute w-full h-full clippedBg"
          style="backdrop-filter: blur(8px)"
        ></div>
        <div
          class="h-full w-full overflow-hidden opacity-40 absolute rounded-content-md"
        >
          <div class="w-full h-full clippedBg pubContainerBg"></div>
        </div>
        <div class="absolute w-[80%] h-[90%] left-5 -top-6">
          <div
            class="h-full w-full overflow-hidden absolute rounded-content-md"
          >
            <div
              class="w-full h-full clippedFrontCard frontCardBg p-6 flex flex-col"
            >
              <div class="font-bold text-4xl">
                <span class="text-[#ffe6ea]">
                  {{ walletInfo?.balance || 0 }}
                </span>
                <span class="text-[#fe798c] text-3xl"> FCFA </span>
              </div>
              <div class="text-lg">
                {{ $t('wallet.availableBalance') }}
              </div>
              <div class="mt-auto">
                <button
                  class="buttonComponent small !bg-none !p-1 flex gap-1 items-center"
                  @click="
                    $Commons.copy(
                      userData?.metaData?.publicId,
                      $t('wallet.accountReferenceCopied'),
                    )
                  "
                >
                  <div>#{{ userData?.metaData?.publicId }}</div>
                  <div class="w-4 h-4">
                    <img src="@/assets/images/all/copy-white.svg" alt="" />
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- <button
          class="buttonComponent small absolute -bottom-2 right-4"
          @click="launchDeposit"
        >
          {{ $t('wallet.depositWithdraw') }}
        </button> -->
        <button
          class="buttonComponent small absolute -bottom-2 right-4"
          @click="launchWalletOperation"
        >
          {{ $t('wallet.walletOperation') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import AppDataProperty from './AppDataProperty.vue'
import UserProperty from '../user/UserProperty.vue'

export default defineComponent({
  name: 'WalletResume',
  components: { AppDataProperty, UserProperty },
  props: {},
  data() {
    return { walletInfo: {}, userData: {}, eventsIds: [] }
  },
  mounted() {},
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    launchWalletOperation() {
      this.$Events.dispatchEvent('service_launching_requested', {
        serviceId: 'wallet',
      })
    },
    launchDeposit() {
      this.$Events.dispatchEvent('deposit_action_requested')
    },
  },
  computed: {},
})
</script>

<style scoped>
.clippedFrontCard {
  clip-path: polygon(0% 0%, 100% 0%, 80% 95%, 0% 100%);
}
.frontCardBg {
  background: linear-gradient(
    169.36deg,
    rgba(255, 92, 116, 0.94) 44.87%,
    rgba(244, 24, 57, 0.94) 100.97%
  );
}
.clippedBg {
  clip-path: polygon(0% 0%, 50% 8%, 100% 0%, 100% 100%, 50% 95%, 0% 100%);
}
.pubContainerBg {
  background: #242c3b
    linear-gradient(
      169.98deg,
      rgba(131, 108, 143, 0.47) 27.98%,
      rgba(120, 48, 166, 0.47) 81.2%
    );
  background: #242c3b
    linear-gradient(
      169.98deg,
      rgba(185, 158, 199, 0.47) 27.98%,
      rgba(194, 97, 255, 0.47) 81.2%
    );
}
.light .pubContainerBg {
  background: white;
}
</style>
